export default "__VITE_ASSET__1f0400d8__"